export const GAME_FIELD_GHOST_DURATION = 75;

export const GAME_FIELD_DISABLED_DELAY = 200;
